import React from "react";
import "../../styles/Header.css";
import logo from "../../assets/logo_pasti.png";
import flag from "../../assets/selangor.png";



const Header = ({ title, onMenuClick, userRole, drawerOpen, }) => {

    return (
        <header className="header-container">
            {/* Hamburger Icon */}
            <button
                className="menu-button"
                onClick={(e) => {
                    e.stopPropagation();
                    if (!drawerOpen) {
                        console.log("🛑 Menu button clicked, toggling sidebar.");
                        onMenuClick();
                    }
                }}
            >
                ☰
            </button>


            {/* Logo Before Title */}
            <img src={logo} alt="Logo PASTI" className="header-logo" />
            <img src={flag} alt="Logo PASTI" className="header-flag" />

            {/* Title */}
            <h1 className="header-title">{title || "PASTI Inventory Dashboard"}</h1>


            <span className={`role-badge ${userRole}`}>
                {userRole === "pengurus"
                    ? "Pengurus"
                    : userRole === "pengarah"
                        ? "Pengarah"
                        : userRole === "pengerusi"
                            ? "Pengerusi"
                            : "Tidak Diketahui"}
            </span>

        </header>
    );
};


export default Header;
